import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

interface ReferralSuccessScreenProps {
  children: React.ReactNode;
  hideDownloadButton?: boolean;
}

export const ReferralSuccessScreen = ({
  children,
  hideDownloadButton = false,
}: ReferralSuccessScreenProps) => {
  return (
    <div className="vai-flex vai-flex-col vai-items-center vai-justify-center vai-min-h-[400px] vai-text-center vai-p-8">
      <div className="vai-mb-8">
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="vai-h-16 vai-w-16 vai-text-green-500 vai-mb-4"
        />
        <h2 className="vai-text-2xl vai-font-bold vai-text-gray-800 vai-mb-2">
          <Trans>Referral Submitted Successfully!</Trans>
        </h2>
        {!hideDownloadButton && (
          <p className="vai-text-gray-600 vai-max-w-md">
            <Trans>
              Your referral has been sent. Download a copy for your records now
              or access it later from the patient list.
            </Trans>
          </p>
        )}
      </div>

      {children}

      {!hideDownloadButton && (
        <p className="vai-text-sm vai-text-gray-500 vai-mt-4 vai-max-w-md">
          <Trans>
            This PDF contains all the referral information including patient
            details, treatment information, and attached images.
          </Trans>
        </p>
      )}
    </div>
  );
};
